import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class CsvErrorsService {
  // emitting the default error to be null
  csvErrors = new BehaviorSubject(null);
}
